import moment from 'moment'
import { faCamera, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import {
  Card,
  CardHeader,
  CardImg,
  Col,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
} from 'reactstrap'
import {
  default as CustomSelect,
  LanguageSelect,
  default as Select,
} from 'views/pages/Group/Select'

import defaultImage from 'assets/img/default-image.png'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import {
  changeEnrollment,
  changeEnrollmentPeriodType,
  fetchAllKeywords,
  fetchAreAllLanguagesPromoted,
  genereateNewCode,
  onResetExpirationDate,
  promoteAllLanguages,
  resetCourseProgress,
  setCourseLanguage,
  setCertificateFooterContent,
} from 'store/Course/actions'
import { fetchGeneralSettings } from 'store/ConfigurationSettings/GeneralConfig/actions'
import AxiosInstance from 'utils/AxiosInstance'
import { isTextEmpty } from 'utils/helpers'
import DefaultSelect, { CreatableSelect } from 'views/pages/Select'
import Hints from 'views/pages/UIElements/Hints'
import TextEditor from 'views/pages/TextEditor'
import { changeEnrollmentPeriod } from 'store/Course/actions'
import { changePrice } from 'store/Course/actions'

const isHtmlContentEmpty = (html) =>
  !html || !html.replace(/<[^>]*>/g, '').trim().length

// import { resetCourseProgress } from 'store/Course/actions'
const expirationPeriodText = (period) => {
  switch (period) {
    case 'd':
      return 'days'
    case 'w':
      return 'weeks'
    case 'm':
      return 'months'
    case 'y':
      return 'years'
    default:
      return 'Wrong date format! Please change expire date.'
  }
}

const enrollmentTypes = [
  { id: 0, name: 'Free of Charge' },
  { id: 1, name: 'Locked' },
  { id: 2, name: 'Paid' },
]

const enrollmentPeriods = [
  { id: 0, name: 'Unlimited' },
  { id: 1, name: 'Specific Date' },
  { id: 2, name: 'Limited Uses' },
]

const CourseImage = (props) => {
  let language = props.language || {}

  return (
    <div className='position-relative change-course-thumbnail content-box course-thumbnail-admin d-flex align-items-center justify-content-center'>
      {props?.image?.includes(
        'https://s3.eu-central-1.amazonaws.com/tazikis-app',
      ) ? (
        <CardImg
          alt='...'
          src={props.thumbValue ? props.thumbValue : defaultImage}
          style={{ objectFit: 'cover' }}
        />
      ) : (
        <CardImg
          alt='...'
          src={
            props.thumbValue
              ? props.thumbValue
              : props.image
                ? props.image
                : defaultImage
          }
          style={{ objectFit: 'cover' }}
        />
      )}

      <div className='hover-overlay-img'>
        <input
          className='change-course-img'
          type='file'
          onChange={(evt) =>
            props.onSelectCourseThumb(evt.target.files[0], evt.target.value)
          }
        />
        <div className='overlay-text'>
          <FontAwesomeIcon icon={faCamera} className='overlay-icon' />
          <p>{language.courses ? language.courses.edit_course_image : null}</p>
        </div>
      </div>

      {!props.thumbValue && !props.image ? (
        <p className='no-course-image-label'>
          {language.courses ? language.courses.no_image_uploaded : null}
        </p>
      ) : null}
    </div>
  )
}

function CourseSettings(props) {
  const dispatch = useDispatch()
  let language = props.language || {}

  const today = moment().format('YYYY-MM-DD')
  const defaultExpiration = moment().add(7, 'days').format('YYYY-MM-DD')

  const equivalentCourse = useSelector(
    (state) => state.courses.equivalentCourse,
  )
  const {
    certificateFooter: generalCertificateFooterEnabled,
    certificateFooterContent: generalCertificateFooterContent,
  } = useSelector((state) => state.generalConfig)

  const usingGeneralCertificateFooter = isHtmlContentEmpty(
    props.certificateFooterContent,
  )
  const certificateFooterContentToShow = usingGeneralCertificateFooter
    ? generalCertificateFooterContent
    : props.certificateFooterContent
  const expirationDate =
    typeof props.expiration_date === 'string'
      ? props.expiration_date.split(' ')
      : `${props.expireDate} ${props.expirePeriod}`.split(' ')
  const expireNumber = expirationDate[0]
  const expirePeriod = expirationDate[1]

  useEffect(() => {
    props.fetchCourseAvailableLanguages(props.course_id)
    props.fetchAllCourses()
    dispatch(onResetExpirationDate())
    dispatch(fetchAllKeywords())
    dispatch(fetchAreAllLanguagesPromoted(props.course_id))
    dispatch(fetchGeneralSettings())
  }, [])

  return (
    <Card className='h-100 px-2'>
      <Col>
        <CardHeader>
          <h5 className='h3 mb-0'>{language.general.my_settings} </h5>
        </CardHeader>
      </Col>
      <div className='d-lg-flex '>
        <Col lg='6'>
          <Card>
            <CourseImage
              {...props}
              language={language}
              onSelectCourseThumb={props.onSelectCourseThumb}
            />
            <ListGroup flush>
              <ListGroupItem className='pr-2'>
                <div className='promote-course py-2'>
                  <label
                    className='p-0 m-0 mr-2 heading text-muted cursor-pointer'
                    htmlFor='promo_course'
                  >
                    {language.learning_plan
                      ? language.learning_plan.promote_in_dashboard
                      : null}
                  </label>
                  <input
                    id='promo-course'
                    type='checkbox'
                    name='promote'
                    onChange={props.onChange}
                    checked={props.promote || false}
                  />
                </div>
              </ListGroupItem>
              <ListGroupItem className='pr-2'>
                <div className='promote-course py-2'>
                  <label
                    className='p-0 m-0 mr-2 heading text-muted cursor-pointer'
                    htmlFor='promo_course'
                  >
                    Promote for all languages
                    <input
                      id='promo-all-course'
                      type='checkbox'
                      name='promote-all'
                      onChange={() =>
                        dispatch(promoteAllLanguages(props.course_id))
                      }
                      checked={props.allLanguagesPromoted || false}
                    />
                  </label>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <FormGroup className='mb-0 ml-0'>
                  <label
                    className='form-control-label text-darker'
                    htmlFor='exampleFormControlTextarea3'
                  >
                    {language.learning_plan
                      ? language.learning_plan.course_description
                      : null}
                  </label>
                  <Input
                    id='course-description-ta'
                    name='description'
                    resize='none'
                    rows='4'
                    type='textarea'
                    onChange={(e) => {
                      if (isTextEmpty(e.target.value)) {
                        alert('Course description cannot be empty!')
                        return
                      }
                      props.onChange(e)
                    }}
                    value={props.description}
                    placeholder={
                      language.learning_plan
                        ? language.learning_plan.description_of_the_course
                        : null
                    }
                  />
                </FormGroup>
              </ListGroupItem>

              {/* {props.courseConfig.enableCourseRedirectUrl === 1 ? ( */}
              <ListGroupItem>
                <FormGroup className='ml-0'>
                  <label className='form-control-label '>
                    {language.courses ? language.courses.redirect_url : null}
                  </label>
                  <Input
                    style={{ width: '100%', marginBottom: '10px' }}
                    // className='gray-bg-input'
                    type='text'
                    onChange={(evt) => props.setRedirectUrl(evt.target.value)}
                    value={props.redirectUrl || ''}
                    placeholder={
                      language.courses ? language.courses.redirect_url : null
                    }
                  />
                </FormGroup>
              </ListGroupItem>

              <ListGroupItem>
                <label className='form-control-label '>
                  {language.courses ? language.courses.response_url : null}
                </label>
                <p
                  style={{
                    fontSize: '13px',
                    wordWreak: 'break-all',
                    fontStyle: 'italic',
                    wordBreak: 'break-all',
                  }}
                >
                  {/* {baseURL() + */}
                  {
                    '/courses/update-external-course-progress?course_id={COURSE_ID}&user_id={USER_ID}&token={TOKEN}'
                  }
                </p>
              </ListGroupItem>

              {generalCertificateFooterEnabled ? (
                <ListGroupItem>
                  <FormGroup className='mb-0 ml-0'>
                    <label className='form-control-label '>
                      Certificate Footer
                    </label>
                    <p
                      style={{
                        fontSize: '12px',
                        fontStyle: 'italic',
                        color: '#8898aa',
                      }}
                    >
                      {usingGeneralCertificateFooter
                        ? "This course is using the general certificate footer. Edit it below to set a footer specific to this course's certificate and emails."
                        : "This course has its own certificate footer, used on this course's certificate and emails."}
                    </p>
                    <div className='cert-footer-editor'>
                      <TextEditor
                        textContent={certificateFooterContentToShow}
                        onChangeText={(value) =>
                          dispatch(setCertificateFooterContent(value))
                        }
                        setOptions={{
                          buttonList: [
                            ['undo', 'redo', 'fontSize', 'formatBlock', 'list'],
                            ['bold', 'underline', 'italic'],
                            ['link'],
                          ],
                        }}
                      />
                    </div>
                  </FormGroup>
                </ListGroupItem>
              ) : null}
              {/* ) : null} */}
            </ListGroup>
          </Card>
        </Col>
        <Col lg='6'>
          <ListGroup flush>
            <ListGroupItem className='py-1'>
              <p className='heading'>
                {' '}
                {language.learning_plan
                  ? language.learning_plan.promote_in_dashboard
                  : null}
              </p>
            </ListGroupItem>
            <ListGroupItem>
              <FormGroup className='ml-0'>
                <label className='form-control-label text-darker'>
                  {language.settings ? language.settings.add_language : null}
                </label>
                <LanguageSelect
                  options={props.languages}
                  selectedOptions={props.courseAvailableLanguages}
                  onChange={props.setCourseAvailableLanguages}
                  placeholder={
                    language.settings ? language.settings.add_language : null
                  }
                  multi={true}
                  valueKey={'id'}
                  language={props.language}
                />
              </FormGroup>

              <FormGroup className='ml-0'>
                <label className='form-control-label text-darker'>
                  {language.courses ? language.courses.select_language : null}
                </label>

                <CustomSelect
                  options={props.availableLanguagesOptions.map(
                    (item, index) => {
                      return { value: item.id, name: item.name }
                    },
                  )}
                  onChange={(e) => dispatch(setCourseLanguage(e))}
                  placeholder={
                    props?.availableLanguagesOptions?.find(
                      (language) => language?.id === props?.language_id,
                    )?.name || ''
                  }
                  selectedOption={{ name: 'English', value: '1' }}
                />
                {/* <Input
                  name='language'
                  type='select'
                  value={props.language_id || ''}
                  onChange={props.setCourseLanguage}
                >
                  {props.availableLanguagesOptions &&
                    props.availableLanguagesOptions.map((item, index) => (
                      <option key={index} selectkey={index} value={item.id}>
                        {item.name ? item.name : ''}
                      </option>
                    ))}
                </Input> */}
              </FormGroup>

              <FormGroup className='ml-0'>
                {props.isDefaultCourse !== 1 ? (
                  <div className='tl-course-promotion'>
                    <button
                      className='btn btn-danger'
                      onClick={() =>
                        props.removeCourseTranslation(props.course_id)
                      }
                    >
                      {language.courses
                        ? language.courses.remove_translation
                        : null}
                    </button>
                  </div>
                ) : null}
              </FormGroup>

              <div className='tl-course-promotion expires__container'>
                {props.expiration_date && props.expiration_date.length && (
                  <>
                    <label className='form-control-label text-darker'>
                      Expires In: {expireNumber.length <= 2 && expireNumber}{' '}
                      {expirationPeriodText(expirePeriod)}
                    </label>

                    <Hints
                      message={"User's progress resets after this period!"}
                    />
                  </>
                )}
              </div>

              {props.setExpirationDate &&
                props.expiration_date &&
                expirationDate.length && (
                  <div className='custom-control custom-checkbox-info round mb-3'>
                    <input
                      className='custom-control-input'
                      id='setChangeExpirationDate'
                      type='checkbox'
                      name='setChangeExpirationDate'
                      onChange={props.onChangeExpirationDate}
                      checked={props.setChangeExpirationDate || false}
                    />
                    <label
                      className='custom-control-label form-control-label text-darker'
                      htmlFor='setChangeExpirationDate'
                    >
                      {`Change Expiring Date`}
                    </label>
                  </div>
                )}
              <FormGroup className='settings-checkbox ml-0'>
                {/* {[1].includes(props.user.access) ? ( */}
                <div className='tl-course-promotion'>
                  {props.setExpirationDate &&
                  props.expiration_date &&
                  props.expiration_date.length ? (
                    ''
                  ) : (
                    <div>
                      <label className='w-100'>
                        <h5 style={{ fontSize: '13px', marginBottom: '5px' }}>
                          {`Set Expiring Date`}:
                        </h5>
                      </label>
                      <input
                        className='gen-form-text-input days-nr'
                        type='text'
                        name='expire-date-value'
                        value={props.expireDate || ''}
                        onChange={props.setExpireDate}
                      />
                      <select
                        className='btn btn-has-dropdown ml-2'
                        name='expire-date-select'
                        value={props.expirePeriod || ''}
                        onChange={props.setExpirePeriod}
                      >
                        <option value='d'>
                          {language.groups ? language.groups.days : null}
                        </option>
                        <option value='w'>
                          {language.groups ? language.groups.weeks : null}
                        </option>
                        <option value='m'>
                          {language.groups ? language.groups.months : null}
                        </option>
                        <option value='y'>
                          {language.groups ? language.groups.years : null}
                        </option>
                      </select>
                    </div>
                  )}

                  {props.expireDate && (
                    <div className='custom-control custom-checkbox-info round mb-3'>
                      <input
                        className='custom-control-input'
                        id='setExpirationDate'
                        type='checkbox'
                        name='setExpirationDate'
                        onChange={props.onSetExpirationDate}
                        checked={props.setExpirationDate || false}
                      />
                      <label
                        htmlFor='setExpirationDate'
                        className='custom-control-label form-control-label text-darker'
                      >
                        {`Enable Expiring Date`}
                      </label>
                    </div>
                  )}
                </div>
                <div className='custom-control custom-checkbox-info round mb-3'>
                  <input
                    className='custom-control-input'
                    id='inactive'
                    type='checkbox'
                    name='course-is-inactive'
                    onChange={props.onChangeIsActiveCourse}
                    checked={props.inactive || false}
                  />
                  <label
                    className='custom-control-label form-control-label text-darker'
                    style={{ zIndex: -1 }}
                    htmlFor='inactive'
                  >
                    {language.general ? language.general.inactive : null}{' '}
                  </label>
                </div>

                {/* <div className='custom-control custom-checkbox-info round mb-3'>
                  <input
                    className='custom-control-input'
                    id='language-ready'
                    type='checkbox'
                    name='language-is-ready'
                    onChange={props.onChangeLanguageIsReady}
                    checked={props.languageIsReady === 1 ? true : false}
                  />
                  <label
                    className='custom-control-label form-control-label text-darker'
                    htmlFor='language-ready'
                  >
                    {language.courses
                      ? language.courses.language_is_ready
                      : null}{' '}
                  </label>
                </div> */}

                <div className='custom-control custom-checkbox-info round mb-3'>
                  <input
                    className='custom-control-input'
                    id='second-level-approval'
                    type='checkbox'
                    name='second-level-approval'
                    onChange={props.onChangeSecondLevelApproval}
                    checked={props.secondLevelApproval || false}
                  />
                  <label
                    className='custom-control-label form-control-label text-darker'
                    htmlFor='second-level-approval'
                  >
                    {language.courses
                      ? language.courses.enable_second_level_approval
                      : null}
                  </label>
                </div>
              </FormGroup>
              <FormGroup className='ml-0'>
                {/* {[1].includes(props.user.access) ? ( */}
                <label className=' form-control-label text-darker'>
                  {language.courses
                    ? language.courses.course_equivalence
                    : null}
                </label>

                <Select
                  options={props && props.allCourses}
                  selectedOptions={props.equivalentCourse}
                  onChange={props.setEquivalentCourse}
                  placeholder={
                    language.courses
                      ? language.courses.add_equivalent_course
                      : null
                  }
                  multi={false}
                  valueKey={'id'}
                  clearable={true}
                />

                {/* ) : null} */}
              </FormGroup>
              <FormGroup className='ml-0'>
                <label className=' form-control-label text-darker'>
                  {language.courses ? language.courses.keywords : null}
                </label>

                <CreatableSelect
                  options={props.availableKeywords || []}
                  selectedOptions={props.keywords || []}
                  onChange={props.setKeywords}
                  placeholder={'Select keyword'}
                />
              </FormGroup>
              <FormGroup className='pb-0 mb-0 ml-0'>
                <div className='col-3 px-0'>
                  <label className=' form-control-label text-darker'>
                    {language.courses ? language.courses.reward_points : null}
                  </label>
                  <Input
                    name='rewardPoints'
                    onChange={props.onChange}
                    value={props.rewardPoints}
                    className='gray-bg-input'
                    type='number'
                    placeholder={'e. g 30'}
                  />
                </div>
              </FormGroup>
              {props.allowPublicAccess === 1 ? (
                <FormGroup className='ml-0 mt-3'>
                  <label className=' form-control-label text-darker'>
                    Enrollment type
                  </label>

                  <DefaultSelect
                    name='enrollmentType'
                    options={enrollmentTypes}
                    selectedOptions={enrollmentTypes.find(
                      (type) => type.id === props.enrollmentType,
                    )}
                    onChange={(e) => dispatch(changeEnrollment(e.option.id))}
                    multi={false}
                    valueKey={'enrollment'}
                    clearable={false}
                  />

                  {/* ) : null} */}
                </FormGroup>
              ) : null}
              {props.allowPublicAccess === 1 && props.enrollmentType === 1 ? (
                <>
                  <FormGroup className='ml-0 mt-3'>
                    <label className=' form-control-label text-darker'>
                      Enrollment period
                    </label>

                    <DefaultSelect
                      name='enrollmentPeriodType'
                      options={enrollmentPeriods}
                      selectedOptions={enrollmentPeriods.find(
                        (period) => period.id === props.enrollmentPeriodType,
                      )}
                      onChange={(e) =>
                        dispatch(changeEnrollmentPeriodType(e.option.id))
                      }
                      multi={false}
                      valueKey={'enrollmentPeriodType'}
                      clearable={false}
                    />

                    {/* ) : null} */}
                  </FormGroup>
                  {props.enrollmentPeriodType === 1 && (
                    <FormGroup className='pb-0 ml-0'>
                      <div className='col-5 px-0'>
                        <label className=' form-control-label text-darker'>
                          Access Expiration Date
                        </label>
                        <Input
                          name='birthdate'
                          id='birthdate'
                          type='date'
                          min={today}
                          defaultValue={
                            props.enrollmentPeriod || defaultExpiration
                          }
                          onChange={(e) =>
                            dispatch(changeEnrollmentPeriod(e.target.value))
                          }
                          style={{ height: '38px' }}
                        />
                      </div>
                    </FormGroup>
                  )}
                  {props.enrollmentPeriodType === 2 && (
                    <FormGroup className='pb-0 ml-0'>
                      <div className='col-3 px-0'>
                        <label className=' form-control-label text-darker'>
                          # of uses
                        </label>
                        <Input
                          onBlur={(e) => {
                            dispatch(changeEnrollmentPeriod(+e.target.value))
                          }}
                          defaultValue={props.enrollmentPeriod || 50}
                          className='gray-bg-input'
                          type='number'
                        />
                      </div>
                    </FormGroup>
                  )}
                  <button
                    onClick={() => {
                      AxiosInstance.get(
                        `/courses/access-code/${props.course_id}`,
                      ).then((data) => {
                        navigator.clipboard.writeText(data?.access_code)
                        toast.success(`Code has been copied to clipboard`, {
                          position: toast.POSITION.TOP_CENTER,
                          className: 'general-settings-toast',
                          autoClose: 2500,
                        })
                      })
                    }}
                    className='btn btn-info'
                  >
                    Copy access code to clipboard
                  </button>
                  <button
                    className='btn btn-info'
                    onClick={() => {
                      if (
                        !window.confirm(
                          'Generating new code will invalidate the old one',
                        )
                      ) {
                        return
                      }
                      dispatch(genereateNewCode())
                    }}
                  >
                    Generate new code
                  </button>
                </>
              ) : null}
              {props.allowPublicAccess === 1 && props.enrollmentType === 2 ? (
                <FormGroup className='pb-0 ml-0'>
                  <div className='col-3 px-0'>
                    <label className=' form-control-label text-darker'>
                      Price
                    </label>
                    <div className='d-flex align-items-center'>
                      <FontAwesomeIcon
                        icon={faDollarSign}
                        className='mr-2'
                        size='lg'
                      />
                      <Input
                        onBlur={(e) => {
                          dispatch(changePrice(+e.target.value))
                        }}
                        defaultValue={props.price || 9.99}
                        className='gray-bg-input'
                        type='number'
                      />
                    </div>
                  </div>
                </FormGroup>
              ) : null}
            </ListGroupItem>
            <ListGroupItem>
              <FormGroup className='ml-0'>
                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='allowPublicAccess'
                      type='checkbox'
                      name='allowPublicAccess'
                      onChange={props.onChange}
                      checked={props.allowPublicAccess === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    Allow public access
                  </label>
                </div>
                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='remindUsers'
                      type='checkbox'
                      name='remindUsers'
                      onChange={props.onChange}
                      checked={props.remindUsers === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    Remind in progress/not started users via email
                  </label>
                </div>

                {props.remindUsers === 1 ? (
                  <div className='d-flex align-items-center mb-3 '>
                    <input
                      className='gen-form-text-input days-nr'
                      type='number'
                      min={1}
                      value={props.emailFrequency?.split(' ')?.at(0) || 1}
                      onChange={(e) =>
                        props.setEmailFrequency(
                          `${e.target.value} ${
                            props.emailFrequency?.split(' ')?.at(1) || 'd'
                          }`,
                        )
                      }
                    />
                    <select
                      className='btn btn-has-dropdown ml-2'
                      value={props.emailFrequency?.split(' ')?.at(1) || 'd'}
                      onChange={(e) =>
                        props.setEmailFrequency(
                          `${
                            props.emailFrequency?.split(' ')?.at(0) || 1
                          } ${e.target.value}`,
                        )
                      }
                    >
                      <option value='d'>
                        {language.groups ? language.groups.days : 'Days'}
                      </option>
                      <option value='w'>
                        {language.groups ? language.groups.weeks : 'Weeks'}
                      </option>
                    </select>
                    <label className='mt-1 form-control-label text-darker ml-3 mb-0'>
                      Frequency
                    </label>
                  </div>
                ) : null}

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='selfAssignable'
                      type='checkbox'
                      name='selfAssignable'
                      onChange={props.onChange}
                      checked={props.selfAssignable === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {language.courses
                      ? language.courses.can_be_self_assigned ||
                        'can_be_self_assigned*'
                      : null}
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='dontShowOnManagerReport'
                      type='checkbox'
                      name='dontShowOnManagerReport'
                      onChange={props.onChange}
                      checked={
                        props.dontShowOnManagerReport === 1 ? true : false
                      }
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {/* {language.settings
                      ? language.courses.dont_show_on_manager_report
                      : `Don't add to Managers Report`} */}
                    Don't add to Managers Report
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='hideCourseSidebar'
                      type='checkbox'
                      name='hideCourseSidebar'
                      onChange={props.onChange}
                      checked={props.hideCourseSidebar === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {language.settings
                      ? language.settings.hide_course_sidebar
                      : null}
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='doNotShowCertificate'
                      type='checkbox'
                      name='doNotShowCertificate'
                      onChange={props.onChange}
                      checked={props.doNotShowCertificate === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {language.settings
                      ? language.settings.do_not_show_certificate
                      : null}
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='disablePdfDownload'
                      type='checkbox'
                      name='disablePdfDownload'
                      onChange={props.onChange}
                      checked={props.disablePdfDownload === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {language.settings
                      ? language.settings.disable_pdf_download
                      : null}
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='allowCourseFeedback'
                      type='checkbox'
                      name='allowCourseFeedback'
                      onChange={props.onChange}
                      checked={props.allowCourseFeedback === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {language.settings
                      ? language.settings.allow_feedback_rating
                      : null}
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='allowCourseComments'
                      type='checkbox'
                      name='allowCourseComments'
                      onChange={props.onChange}
                      checked={props.allowCourseComments === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    {language.settings
                      ? language.settings.allow_course_comments
                      : null}
                  </label>
                </div>

                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='enableCompletionFeedback'
                      type='checkbox'
                      name='enableCompletionFeedback'
                      onChange={props.onChange}
                      checked={
                        props.enableCompletionFeedback === 1 ? true : false
                      }
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    Enable course completion feedback
                  </label>
                </div>
                <div className='d-flex'>
                  <label className='custom-toggle mr-4'>
                    <input
                      id='requireAgreement'
                      type='checkbox'
                      name='requireAgreement'
                      onChange={props.onChange}
                      checked={props.requireAgreement === 1 ? true : false}
                    />
                    <span className='custom-toggle-slider rounded-circle' />
                  </label>
                  <label className=' form-control-label text-darker'>
                    Require Agreement Before Certification
                  </label>
                </div>
              </FormGroup>
              <button
                disabled={props.resettingProgress}
                onClick={() => dispatch(resetCourseProgress(props?.course_id))}
                className='btn btn-info w-auto my-2'
              >
                {!props?.resettingProgress
                  ? 'Reset Progress'
                  : 'Resetting Progress...'}
              </button>
            </ListGroupItem>
          </ListGroup>
        </Col>
      </div>
    </Card>
  )
}

export default CourseSettings
